import * as React from 'react';
import { InnerSection } from 'components/layouts/CommonForm';
import { useEffect, useState } from 'react';
import { ItemType } from 'components/multiSelectContainer/types';
import { useMultiSelect } from 'components/multiSelectContainer/useMultiSelect';
import ServiceHelper from 'stores/ServiceHelper';
import VoucherItemList from 'components/multiSelectContainer/VoucherItemList';
import { ItemTypeExtended } from 'types/CommonTypes';
import styled from 'styled-components';
import { Button, ButtonGroup } from '@mui/material';

const AllListings = ({
  onChange,
  value,
}: {
  onChange?: (ids: number[]) => void;
  value?: number[];
}) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [listings, setListings] = useState<ItemTypeExtended[]>([]);

  const { covertModelToItem } = useMultiSelect<ItemType & { id: number }>(
    listings.filter((l): l is ItemType & { id: number } => l.id !== undefined),
  );

  /**
   * @description 전체 숙소 취득
   */
  const fetchListings = async (immediate: boolean = false) => {
    const result = await ServiceHelper.adminListingService?.getListings1({ size: 100 });
    const filteredListings = result?.data
      .map((listing) => covertModelToItem(listing))
      .filter((listing) => !listings?.some((checked) => checked.id === listing.id));
    const resultListing = filteredListings as ItemType[];
    if (immediate) {
      return resultListing;
    } else {
      setListings(resultListing);
    }
  };

  const updateListings = async () => {
    await fetchListings(true).then((result) => {
      const newListings = result?.map((listing) => ({
        ...listing,
        selected: value?.includes(listing.id as number) ?? false,
      }));

      setListings(newListings as ItemTypeExtended[]);
    });
  };

  // 전체 선택 함수
  const handleSelectAll = () => {
    const allSelected = listings.map((item) => ({
      ...item,
      selected: true,
    }));
    setListings(allSelected);

    // onChange 호출 - 모든 아이템의 ID를 전달
    const allIds = listings.map((item) => item.id).filter((id) => id !== undefined) as number[];
    onChange?.(allIds);
  };

  // 전체 선택 해제 함수
  const handleDeselectAll = () => {
    const allDeselected = listings.map((item) => ({
      ...item,
      selected: false,
    }));
    setListings(allDeselected);

    // onChange 호출 - 빈 배열 전달
    onChange?.([]);
  };

  useEffect(() => {
    if (isLoaded) {
      return;
    }
    if (value) {
      updateListings();
    } else {
      fetchListings();
    }
    setIsLoaded(true);
  }, [value]);

  return (
    <div>
      <ButtonContainer>
        <ButtonGroup variant="outlined" size="small">
          <Button onClick={handleSelectAll}>전체 선택</Button>
          <Button onClick={handleDeselectAll}>선택 해제</Button>
        </ButtonGroup>
      </ButtonContainer>
      <InnerSection style={{ padding: 0 }}>
        <VoucherItemList
          style={{ maxHeight: '80%', height: 'auto' }}
          items={listings}
          usePhoto={false}
          onChange={(items: ItemType[]) => {
            const ids = items.map((o) => o.id).filter((o) => o !== undefined);
            onChange?.(ids as number[]);
          }}
        />
      </InnerSection>
    </div>
  );
};

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
`;

export default AllListings;
